module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_LT-4c8a1c47e92cc36a35dec436c2f6c716.svg";